export const workModes = ['WFO', 'WFH']

export const indonesianDayNames = ['Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu', 'Minggu']

export const defaultSchedules = [
  {
    indonesian_day_of_week: indonesianDayNames[0],
    form: {
      work_mode: 0,
      start_clock: '08:00',
      end_clock: '17:00',
    },
  },
  {
    indonesian_day_of_week: indonesianDayNames[1],
    form: {
      work_mode: 0,
      start_clock: '08:00',
      end_clock: '17:00',
    },
  },
  {
    indonesian_day_of_week: indonesianDayNames[2],
    form: {
      work_mode: 0,
      start_clock: '08:00',
      end_clock: '17:00',
    },
  },
  {
    indonesian_day_of_week: indonesianDayNames[3],
    form: {
      work_mode: 0,
      start_clock: '08:00',
      end_clock: '17:00',
    },
  },
  {
    indonesian_day_of_week: indonesianDayNames[4],
    form: {
      work_mode: 0,
      start_clock: '08:00',
      end_clock: '17:00',
    },
  },
  {
    indonesian_day_of_week: indonesianDayNames[5],
    form: {
      work_mode: 0,
      start_clock: '08:00',
      end_clock: '17:00',
    },
  },
  {
    indonesian_day_of_week: indonesianDayNames[6],
    form: {
      work_mode: 0,
      start_clock: '08:00',
      end_clock: '17:00',
    },
  },
]

export const resetButtonTooltip = `
    <p style="font-weight:600; font-size:14px; margin:0 0 .25rem 0; text-align: left;">
      Reset ke Mode Kerja Default
    </p>
    <p style="color:#626262; font-size:12px; margin:0; text-align: left;">
      jadwal shifting akan dihapus dan user akan mengikuti pengaturan mode kerja default.
    </p>
`
